export default [
  { value: 'CANCEL_NO_REFUND', name: '취소완료[환불없음]' },
  { value: 'CANCEL_REQUEST', name: '취소신청[승인대기]' },
  { value: 'CANCEL_PROC_REQUEST_REFUND', name: '취소처리[환불보류]' },
  { value: 'CANCEL_PROC_WAITING_REFUND', name: '취소처리[환불대기]' },
  { value: 'CANCEL_DONE', name: '취소완료[환불완료]' },
  { value: 'RETURN_REQUEST', name: '반품신청[승인대기]' },
  { value: 'RETURN_REJECT_REQUEST', name: '반품신청[철회대기]' },
  { value: 'RETURN_PROC_BEFORE_RECEIVE', name: '반품처리[수거진행]' },
  { value: 'RETURN_PROC_REQUEST_REFUND', name: '반품처리[환불보류]' },
  { value: 'RETURN_REFUND_AMT_ADJUST_REQUESTED', name: '반품처리[조정요청]'},
  { value: 'RETURN_PROC_WAITING_REFUND', name: '반품처리[환불대기]' },
  { value: 'RETURN_DONE', name: '반품완료[환불완료]' },
  { value: 'EXCHANGE_REQUEST', name: '교환신청[승인대기]' },
  { value: 'EXCHANGE_REJECT_REQUEST', name: '교환처리[철회대기]' },
  { value: 'EXCHANGE_PROC_BEFORE_RECEIVE', name: '교환처리[수거진행]' },
  { value: 'EXCHANGE_PROC_REQUEST_PAY', name: '교환처리[결제대기]' },
  { value: 'EXCHANGE_PROC_WAITING_PAY', name: '교환처리[입금처리대기]' },
  { value: 'EXCHANGE_DONE_PAY_DONE', name: '교환완료[결제완료]' },
  { value: 'EXCHANGE_PROC_REQUEST_REFUND', name: '교환처리[환불보류]' },
  { value: 'EXCHANGE_PROC_WAITING_REFUND', name: '교환처리[환불대기]' },
  { value: 'EXCHANGE_DONE_REFUND_DONE', name: '교환완료[환불완료]' },
  { value: 'EXCHANGE_DONE', name: '교환완료' }
];